import { useContext, useEffect, useRef } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import { OrderNoWithCommands } from "./orderNoWithCommands";
import { scrollToFocuse } from "../../../Layout/Common/common";
import { PaymentSection } from "./paymentMethod/paymentSection";
import { PAYMENT_FAILED, SHIPPING_METHOD, SUBMIT_ORDER } from "../../../constants";
import { Link } from "react-router-dom";
import { SubmitOrderNote } from "./submitOrderNote";
import { PAGES } from "../../../routeConfig";
import { usePayNow } from "../../../Context/hook/usePayNow";
import { useNoteAlert } from "../../../Context/pleaseNote";
import {
  fetchTillCheckoutState,
  settleTillCheckoutAsCancel,
  shouldSuppressAutoScroll,
  takeRestoreOutcome,
} from "../../../Context/hook/tillRedirect";
import { useAuth } from "../../../Context/AuthContext";

export const PaymentMain = () => {
  const divcontainerRef = useRef();
  const {
    selectedPaymentType,
    setSelectedPaymentType,
    deliveryMethod,
    shippingCode,
    shippingMode,
    changeShipServiceClicked,
    setNewcardSave,
    setRefreshable,
    CartItem,
  } = useContext(GlobalContext);
  const { userId, role } = useAuth();

  const { handlePayNowClick, paybuttonDisabled, paymentDeclineFunction } = usePayNow();
  const { showDialogAlert, hideNoteAlert } = useNoteAlert();

  useEffect(() => {
    if (changeShipServiceClicked == false && !shouldSuppressAutoScroll())
      scrollToFocuse(divcontainerRef.current, 500, 200);

    return () => {
      setSelectedPaymentType(null);
      setNewcardSave(false);
    };
  }, [changeShipServiceClicked]);

  const showPaymentFailed = () => {
    showDialogAlert({
      content: PAYMENT_FAILED.content,
      title: PAYMENT_FAILED.title,
      primaryBtn: { caption: "Try new card", onClick: paymentDeclineFunction },
      scondaryBtn: { caption: "Ok", onClick: hideNoteAlert },
    });
  };

  useEffect(() => {
    if (takeRestoreOutcome()) showPaymentFailed();
  }, []);

  useEffect(() => {
    const onPageShow = async (event) => {
      if (!event.persisted) return;
      const orderId = CartItem ? CartItem.orderid : null;
      if (orderId == null) return;
      const pendingState = await fetchTillCheckoutState(orderId);
      if (!pendingState) return;
      settleTillCheckoutAsCancel({ orderId, userId });
      setRefreshable(true);
      showPaymentFailed();
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, [CartItem, userId]);

  // Delivery is selected but no shipping service chosen yet — keep it "Pay Now" until a service is picked.
  const deliveryWithoutService = String(deliveryMethod).includes(SHIPPING_METHOD[1]) && !shippingMode;
  const showSubmitOrder =
    role == "3" || (!deliveryWithoutService && (SUBMIT_ORDER.includes(selectedPaymentType) || shippingCode == "TBA"));

  return (
    <div className="col-lg-12">
      <div className="delivery-method" ref={divcontainerRef}>
        <OrderNoWithCommands />
        <PaymentSection />
        <SubmitOrderNote />
        <div className="checkout-button pay-now-checkout">
          <Link to={PAGES.ORDER_DETAIL} className="return-to-cart d-none d-md-block">
            <i className="fa-solid fa-chevron-left" /> Return to Cart
          </Link>
          <div className="button-effect">
            {selectedPaymentType === "TILLGOOGLEPAY" ? (
              <p className="googlepay-hint" style={{ margin: 0, fontSize: 13, color: "#666", display: "none" }}>
                Use the Google Pay button above to complete your payment.
              </p>
            ) : (
              <button className="btn btn-products btn-addcart" onClick={handlePayNowClick}>
                {showSubmitOrder || role === "3" ? "Submit Order" : "Pay Now"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
